import cn from 'classnames';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import MarketWbApi from '../../../../API/market/wb-api';
import SuppliesApi from '../../../../API/shipment/supplies-api';
import { NavTabs, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Select } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../../components/Basic/Table';
import { Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import { MarketsSearch } from '../../../../components/Markets';
import MarketsFilter from '../../../../components/Markets/Blocks/Filter';
import { MARKETS_MAP } from '../../../../constans';
import { numberWithSpaces } from '../../../../utils';
import MarketsLine from './Line';
import styles from './styles.module.scss';

const WIDTH_MARKETPLACE = [
  '110px', //0
  '160px', //1
  '400px', //2
  '100px', //3
  '100px', //4
  '60px', //5
  '150px', //6
  '160px', //7
  '200px', //8
  '150px', //9
  '40px', //10
  '170px', //11
  '120px', //12
  '75px', //13
];

const SORT_TYPE = [
  { name: 'По сумме хранения', value: 'storage_sum' },
  { name: 'По количеству', value: 'storage_count' },
  { name: 'Не выбран', value: undefined },
];

const FILTER_STOCKS = {
  0: 'all',
  1: 'on_sklad',
  2: 'not_on_sklad',
  3: 'way_to_client',
  4: 'way_from_client',
  5: 'is_basketed',
  6: 'is_blocked',
  // 1: 'wb_storage_in_stock',
  // 2: 'wb_storage_has_history',
};

const FILTER = {
  'Режим остатков': FILTER_STOCKS,
};

const MODES = ['Режим остатков'];

const NAVIGATE = {
  'Режим остатков': [
    'Все товары',
    'На складе',
    'Нет на складе',
    'В пути к клиенту',
    'В пути от клиента',
    'В корзине',
    'Заблокированные',
    // 'В продаже',
    // 'С историей хранения',
  ],
};


const WbTable = ({
  shop,
  period = {},
  showPriceControl = false,
  showSale = false,
  setFilter,
  updateProviderStocksAndPrice = () => { },
  updateProviderPrice = () => { },
  ...props
}) => {

  const [show, setShow] = useState(25);
  const [search, setSearch] = useState('');
  const [payStatistic, setPayStatistic] = useState({})
  const [suppliesNumbers, setSuppliesNumbers] = useState([])
  const [warehouses, setWarehouses] = useState([]);

  const allProviders = useSelector((store) => store.providers);
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });
  const [page, setPage] = useState(1);

  const [providers, setProviders] = useState([]);

  const [count, setCount] = useState([]);
  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);

  const [contentMode, changeMode] = useState(MODES[0]);
  const [sortType, setSortType] = useState(SORT_TYPE[0]);

  const [cards, setCards] = useState({ ids: [], byId: {} });

  const { role } = useSelector((store) => store.user);

  const onChangeProduct = async (_id, offer_id, key, value, skladName) => {
    if (cards.byId[_id][key] === value) {
      return;
    }
    let setCard = (card) => {
      setCards({ ...cards, byId: { ...cards.byId, [_id]: card } });
    };
    if (key === 'stock') {
      return await MarketWbApi.changeStock({ data: { shop: MARKETS_MAP[shop], offer_id, value: parseInt(value), skladName } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'price' || key === 'discount') {
      return await MarketWbApi.changePrice({ data: { shop: MARKETS_MAP[shop], offer_id, field: key, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'percent' || key === 'min_rub') {
      return await MarketWbApi.changeMarginality({ data: { shop: MARKETS_MAP[shop], offer_id, field: key, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'stopbrand') {
      return await MarketWbApi.changeStopBrand({ data: { shop: MARKETS_MAP[shop], offerIds: [offer_id], value } })
        .then((r) => {
          loadCards();
        })
        .catch((e) => console.log(e));
    }
    return await MarketWbApi.changeCard({ data: { shop: MARKETS_MAP[shop], offer_id, field: key, value } })
      .then((r) => {
        setCard(r.card);
      })
      .catch((e) => console.log(e));
  };

  const onChangeCards = async (offerIds, key, value) => {
    if (key === 'stopbrand') {
      return await MarketWbApi.changeStopBrand({ data: { shop: MARKETS_MAP[shop], offerIds, value } })
        .then(() => { loadCards() })
    }

    if (key === 'basket') {
      return await MarketWbApi.changeBasket({ data: { shop: MARKETS_MAP[shop], offerIds, value } }).then(() => {
        loadCards();
      });
    }
    if (key === 'images') {
      return await MarketWbApi.uploadImages({ data: { shop: MARKETS_MAP[shop], offerIds } }).then(() => {
        loadCards();
      });
    }

    // if (key === 'stock') {
    //   return await updateProviderStocksAndPrice(undefined, value, offerIds).then(() => {
    //     setProductsSelect({});
    //   });
    // }

    if (key === 'price') {
      return await updateProviderPrice(undefined, offerIds, true).then(() => {
      });
    }
  };


  const onChangeTab = (n) => {
    setTab(n);
  };
  const onChangePage = (v) => {
    setPage(v);
  };

  const params = useMemo(() => {
    return {
      period,
      sortType: sortType.value,
      search: search.trim(),
      limit: parseInt(show),
      page,
      shop: shop === 'Все' ? undefined : MARKETS_MAP[shop],
      providerId: provider.id,
      tab: FILTER[contentMode][tab],
      filters: {
      },
    };
  }, [
    search,
    period,
    show,
    shop,
    tab,
    provider,
    page,
    sortType,
    contentMode,
  ]);

  const loadCards = () => {
    SuppliesApi.getStorageWb({ data: params }).then((r) => {

      setCount(r.count);
      setCountStock(Object.values(r.stock));

      const byIds = {};
      const ids = r.cards.map((item) => item._id);
      r.cards.forEach((item) => (byIds[item._id] = item));

      setCards({ byId: byIds, ids: ids });
      setPayStatistic(r.payStatistic)
      setSuppliesNumbers(r.suppliesNumbers)
    });
  };

  useEffect(() => {
    setFilter(params)
    loadCards();
  }, [params]);



  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    setProviders([{ name: 'Не выбран', id: null }, { name: 'Не заполнен', id: -1 }, ...p]);
  }, [allProviders]);


  useEffect(() => {
    SuppliesApi.getWarehouses({ data: {} }).then(r => {
      setWarehouses(r.warehouses)
    })
  }, []);

  const isOwner = role === 'owner' || role === 'admin';

  return (
    <>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={NAVIGATE[contentMode]}
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />

          <div>
            <Select select={contentMode} list={MODES} onSelect={(v) => changeMode(v)} width="150px" />
          </div>
        </Row>

        <MarketsSearch
          market={'WB'}
          selectTab={FILTER[contentMode][tab]}
          search={search}
          setSearch={setSearch}
          count={count}
          onArchive={(offerIds, state) => onChangeCards(offerIds, 'archive', state)}
          onStopbrand={(offerIds, state) => onChangeCards(offerIds, 'stopbrand', state)}
          updateStocks={(offerIds, state) => onChangeCards(offerIds, 'stock', state)}
          updatePrices={(offerIds) => onChangeCards(offerIds, 'price')}
          toBasket={(offerIds, state) => onChangeCards(offerIds, 'basket', state)}
          updateImages={(offerIds) => onChangeCards(offerIds, 'images')}
        />

        <Row spaceBetween={true}>
          <Row>
            <MarketsFilter
              selectTab={FILTER[contentMode][tab]}
              show={show}
              tab={tab}
              provider={provider}
              providers={providers}
              setShow={setShow}
              changeProvider={changeProvider}
              setSortType={setSortType}
              sortType={sortType}
              SORT_TYPE={SORT_TYPE}
            />
          </Row>

        </Row>
      </WhiteBlock>


      <Table styles={styles.table}>
        <TableHeader whiteHeader>
          <Row className={styles.block_calc}>
            <TextGrey className={styles.text_grey}>Общая сумма хранения: </TextGrey>
            <Text className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(payStatistic.sum))} руб.</Text>
          </Row>
          <Row className={styles.block_calc}>
            <TextGrey className={styles.text_grey}>В среднем за день: </TextGrey>
            <Text className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(payStatistic.sum / (moment(period.end).diff(moment(period.start), 'days') + 1)))} руб.</Text>
          </Row>
          <Row className={styles.block_calc}>
            <TextGrey className={styles.text_grey}>За сегодня: </TextGrey>
            <Text className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(payStatistic.sum_today))} руб.</Text>
          </Row>
        </TableHeader>
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          <HeaderTitle width={WIDTH_MARKETPLACE[13]} centerText>Магазин</HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[5]}></HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[1]}>Артикул</HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[2]}>Название товара</HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>Остаток на складе МП</HeaderTitle>
          {/* <HeaderTitle width={WIDTH_MARKETPLACE[3]} centerText>Дней хранения</HeaderTitle> */}
          <HeaderTitle width={WIDTH_MARKETPLACE[11]} centerText>Сумма хранения / в день / всё время</HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[7]} centerText>
            Цена / Цена до скидки
          </HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText>
            Цена закупки
          </HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText>
            Скидка
          </HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[6]} centerText>
            Прибыль / Комиссия
          </HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText>
            Количество продаж
          </HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[11]} centerText>
            Поставщик
          </HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[7]} centerText>
            Артикул поставщика
          </HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[4]} centerText>
            Количество в заказе
          </HeaderTitle>
          <HeaderTitle width={WIDTH_MARKETPLACE[7]} centerText>
            Артикул на складе
          </HeaderTitle>
        </TableHeader >
        {
          cards.ids.map((key) => (
            <MarketsLine
              warehouses={warehouses}
              market={'WB'}
              contentMode={contentMode}
              key={key}
              isOwner={isOwner}
              isExpress={false}
              item={cards.byId[key]}
              onChangeProduct={onChangeProduct}
              suppliesNumbers={suppliesNumbers}
            />
          ))
        }
      </Table >
      <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />

    </>
  );
};

export default WbTable;
